import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../../base/BaseEntity'
import { RelatedEntity } from '../../base/RelatedEntity'
import { generateEntityId } from '../../generateEntityId'
import { User } from '../../user/User'

/**
 * One redemption of a `Coupon` against a purchase — the audit/enforcement trail behind
 * `Coupon.redemptionCount` and `perUserLimit`. `createdAt` (inherited from `Entity`) is the
 * redemption timestamp.
 */
@ObjectType()
@InputType('CouponRedemptionInput')
@modelOptions({ schemaOptions: { timestamps: true, collection: 'couponredemptions' } })
export class CouponRedemption extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('cpnr') })
  declare _id: string

  @Field(() => ID)
  @Prop({ type: String, required: true })
  couponId: string

  /** Denormalized `Coupon.code` snapshot — avoids a join for display/audit. */
  @Field(() => String)
  @Prop({ type: String, required: true })
  couponCode: string

  /** The redeeming user. */
  @Field(() => User)
  @Prop({ type: RelatedEntity })
  owner: ReturnType<() => User>

  /** The `CreditPurchase._id` this redemption discounted. */
  @Field(() => ID)
  @Prop({ type: String, required: true })
  creditPurchaseId: string

  /** Amount actually deducted from the purchase price by this redemption, in the order's currency. */
  @Field(() => Float)
  @Prop({ type: Number, required: true })
  discountApplied: number
}
